import { Sprout, Camera, Stethoscope, Dot } from 'lucide-react';

/**
 * One entry in the pet's life diary. Three shapes: a milestone (birth/arrival),
 * a photo memory, and a consultation visit with its recommendations and
 * recommended/purchased products. Internal staff material never reaches here.
 */
const ICONS = { milestone: Sprout, photo: Camera, consultation: Stethoscope };

function formatDate(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return '';
  }
}

export function TimelineEntry({ entry, last }) {
  const Icon = ICONS[entry.type] || Dot;
  return (
    <li className="relative flex gap-4">
      {/* Rail + node */}
      <div className="flex flex-col items-center">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-portal-accent-soft text-portal-accent">
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </span>
        {!last && <span className="mt-1 w-px flex-1 bg-portal-border" />}
      </div>

      <div className="flex-1 pb-8">
        <p className="text-xs font-medium uppercase tracking-wide text-portal-ink-faint">{formatDate(entry.date)}</p>
        <h3 className="mt-0.5 font-semibold text-portal-ink">{entry.title}</h3>

        {entry.body && <p className="mt-1 text-portal-ink-muted">{entry.body}</p>}

        {entry.type === 'photo' && entry.photo && entry.photo.url && (
          <div className="mt-3 overflow-hidden rounded-portal shadow-portal">
            <img src={entry.photo.url} alt={entry.photo.caption || 'Ricordo'} className="max-h-72 w-full object-cover" />
          </div>
        )}

        {Array.isArray(entry.recommendations) && entry.recommendations.length > 0 && (
          <ul className="mt-2 list-inside list-disc space-y-0.5 text-sm text-portal-ink-muted">
            {entry.recommendations.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
        )}

        {Array.isArray(entry.products) && entry.products.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {entry.products.map((p, i) => (
              <span
                key={i}
                className={`rounded-full px-3 py-1 text-xs font-medium ${
                  p.purchased
                    ? 'bg-portal-sage-soft text-portal-sage'
                    : 'bg-portal-accent-soft text-portal-accent'
                }`}
              >
                {p.name}{p.purchased ? ' · acquistato' : ' · consigliato'}
              </span>
            ))}
          </div>
        )}
      </div>
    </li>
  );
}
